/** User-facing staking rules — keep in sync with bitzx-mobile-app/src/utils/stakingRules.ts */

export const STAKING_EARLY_WITHDRAW_RULE =
  'If you withdraw before the selected lock period ends, you get back only the BZX you deposited. No profit, rewards, or other staking benefits are paid.';

export const STAKING_REWARDS_WITH_RULE =
  'Earn additional BZX by locking tokens for a selected period. Rewards are paid only at maturity. If you withdraw early, you receive a refund of your deposited BZX only — no profit or other staking benefits.';
